/** Cloudflare RealtimeKit preset for livestream hosts (webinar presenter). */
export const RTK_HOST_PRESET = "webinar_presenter";
